import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useInstitution } from '../contexts/InstitutionContext';
import { INSTITUTIONS_ENABLED } from '../lib/featureFlags';
import { institutionClassroomPath, getSessionWorkspace } from '../lib/institutionOnboarding';
import { PlanGate } from './PlanGate';
import { FullPageLoader } from './ui/page-loader';

export const SubscriptionRequired = ({ children, allowInstitutionPortal = false }) => {
  const { loading, isAuthenticated, hasActiveSubscription, isAdmin } = useAuth();
  const {
    hasInstitutionPlatformAccess,
    hasInstitutionPortalAccess,
    allMemberships,
    loading: instLoading,
  } = useInstitution();
  const institutionPlatformAccess = INSTITUTIONS_ENABLED && hasInstitutionPlatformAccess;
  const institutionPortalAccess = INSTITUTIONS_ENABLED && allowInstitutionPortal && hasInstitutionPortalAccess;
  const classroomPath = institutionClassroomPath(allMemberships, hasActiveSubscription);

  if (loading || (INSTITUTIONS_ENABLED && instLoading)) {
    return <FullPageLoader message="Loading" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (isAdmin) {
    return children;
  }

  if (hasActiveSubscription || institutionPlatformAccess || institutionPortalAccess) {
    return children;
  }

  if (getSessionWorkspace() === 'platform') {
    return <PlanGate />;
  }

  if (classroomPath) {
    return <Navigate to={classroomPath} replace />;
  }

  return <PlanGate />;
};
